@if (teaser !== '') {
  <p>
    {{ teaser }}
  </p>
}
@if (teaserShort !== '') {
  <p class="teaser-short text--bold">
    {{ teaserShort }}
  </p>
}
@if (phonePrefix !== '') {
  <p>{{ phonePrefix }}{{ organisation.contactInfo.phone }}</p>
}
@if (subtitle !== '') {
  <p class="text--bold">{{ subtitle }}</p>
}
<p>
  {{ organisation.name }}<br />
  {{ organisation.address.street }} {{ organisation.address.streetNumber }}<br />
  {{ organisation.address.zipCode }} {{ organisation.address.city }} <br />
  {{ organisation.contactInfo.email }}
</p>

@if (withContactForm) {
  <ez-button
    class="block--centered"
    theme="secondary"
    label="Kontaktformular öffnen"
    (buttonClick)="openContactForm()"
    maxWidth="300px"
  ></ez-button>
}
